import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../wmgr_logo_icon.svg';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Header extends Component {
  render() {
    return (
       
        <Navbar>
        <NavbarGroup align={ Alignment.LEFT}>
            <Logo className="wmgr_logo"/>
            <NavbarHeading>Wellness Matrix Group</NavbarHeading>
            <NavbarDivider />
            <Link to="/">
                <Button className={Classes.MINIMAL}  text="Home" />
            </Link>
            <Link to="/solutions">
                <Button className={Classes.MINIMAL}  text="Solutions" />
            </Link>
            <Link to="/howitworks">
                <Button className={Classes.MINIMAL}  text="How it works" />
            </Link>
            <Link to="/about">
                <Button className={Classes.MINIMAL}   text="About" />
            </Link>
            <Link to="/blog">
                <Button className={Classes.MINIMAL}   text="Blog" />
            </Link>
            <Link to="/contact">
                <Button className={Classes.MINIMAL}   text="Contact" />
            </Link>
        </NavbarGroup>
        <NavbarGroup align={ Alignment.RIGHT}>
                
            <Button  className="nav_button_right"  minimal="true" text="Sign Up" intent="success" />
            <Button  className="nav_button_right"  minimal="true"  text="Login"  intent="primary" />

        </NavbarGroup>

    </Navbar>
    );
  }
}

export default Header;

/*
<Button className={Classes.MINIMAL} icon="user" text="Account" />
                <Button className={Classes.MINIMAL} icon="globe-network" text="Network" />
            <NavbarDivider />
*/